/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ci_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Character Inspector`)
};

const es_ci_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspector de Caracteres`)
};

const de_ci_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeichen-Inspektor`)
};

const nl_ci_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karakterinspecteur`)
};

const fr_ci_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspecteur de caractères`)
};

const it_ci_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ispettore di Caratteri`)
};

const pt_br2_ci_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspetor de Caracteres`)
};

const pt_ci_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspetor de Caracteres`)
};

const ja_ci_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「文字インスペクタ」`)
};

const zh_ci_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字符检查器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ci_nav_main = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ci_nav_main(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ci_nav_main", locale)
	if (locale === "en") return en_ci_nav_main(inputs)
	if (locale === "es") return es_ci_nav_main(inputs)
	if (locale === "de") return de_ci_nav_main(inputs)
	if (locale === "nl") return nl_ci_nav_main(inputs)
	if (locale === "fr") return fr_ci_nav_main(inputs)
	if (locale === "it") return it_ci_nav_main(inputs)
	if (locale === "pt-BR") return pt_br2_ci_nav_main(inputs)
	if (locale === "pt") return pt_ci_nav_main(inputs)
	if (locale === "ja") return ja_ci_nav_main(inputs)
	return zh_ci_nav_main(inputs)
};